import React from 'react';
import { Button, Spacer } from '@chakra-ui/react';
import { Context } from '../../App';
import Resource from '../../model/resource';
import Table, { TableProps } from '../../base-components/Table';
import EditorParent from '@/base-components/EditorParent';
import { ActiveBadge } from '../worksite/WorksitePage';
import { RoutePath, SPACING } from '@/generic/config';
import { useNavigate } from 'react-router-dom';

const ResourceSearchPage = () => {
    const { translations, resources } = React.useContext(Context);
    const navigate = useNavigate();

    const tableProps: TableProps<Resource> = {
        columns: [
            { title: translations.model.resource.id, scale: 1, getter: (r) => r.id },
            { title: translations.model.resource.code, scale: 2, getter: (r) => r.code },
            { title: translations.common.active, scale: 1, getter: (r) => <ActiveBadge active={r.enabled} translations={translations} /> },
        ],
        rows: resources?.data,
        isLoading: resources?.isLoading,
        isRowDisabled: (row) => !row.enabled,
        href: (row) => `${RoutePath.Resources}/${row.id}`,
    };

    return (
        <EditorParent title={translations.model.resource.search.title}>
            <Button my={SPACING} onClick={() => navigate(`${RoutePath.Resources}/new`)}>{translations.common.registerNew}</Button>
            <Table tableProps={tableProps} />
        </EditorParent>
    );
}

export default ResourceSearchPage;
